export default __webpack_public_path__ + "static/logo-color-3c456a63a79c2db20156272dceca7c1c.svg";